import React from 'react';
import axios from 'axios';
import { Input, Form, Button, Header, Table, Loader, Popup, Grid, Divider } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import { DateTimePicker } from 'react-widgets';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class PioMio extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employee: null,
            main: null,
            pioMio: [],

            startDate: null,
            endDate: null,

            editPioMio: false,

            id: null,
            optLock: null,

            newPioMio: false,

            editEmploymentInfo: false,

            kdo: null,
            workExperience: null,
            idE: null,
            optLockE: null,
            loading: true

        };


        this.editPioMio = this.editPioMio.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.getPioMio = this.getPioMio.bind(this);
        this.editEmploymentInfo = this.editEmploymentInfo.bind(this);
        this.deletePioMio = this.deletePioMio.bind(this);
    }


    UNSAFE_componentWillMount() {
        this.setState({
            employee: JSON.parse(localStorage.getItem('employee')),
            main: localStorage.getItem('main') === 'true'
        });
        this.getPioMio();
    }


    getPioMio() {
        axios.get(`pio-mio/${JSON.parse(localStorage.getItem('employee')).id}/`)
            .then(res => {
                this.setState({ pioMio: res.data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch employment contract info.');
            });
    }

    deletePioMio(id) {
        // let obj = { id };
        axios.delete(`pio-mio/delete/${id}`)
            .then(res => {
                this.setState({ confirmation: false });
                toast('Uspješno ste obrisali PIO/MIO.');
                this.getPioMio();
            })
            .catch(err => {
                toast('Došlo je do greške. Brisanje PIO/MIO nije uspjelo.');
            });
    }

    editPioMio() {
        let obj = {
            startDate: this.state.startDate,
            endDate: this.state.endDate
        };

        if (!this.state.newPioMio) obj = { ...obj, optLock: this.state.optLock, id: this.state.id };
        if (this.state.newPioMio) obj = { ...obj, employee: { id: this.state.employee.id } };

        if (this.state.newPioMio) {
            axios.post('pio-mio/', { ...obj })
                .then(res => {
                    this.setState({ newPioMio: false, startDate: null, endDate: null });
                    toast('Podaci za PIO/MIO su uspješno sačuvani.');

                    this.getPioMio();
                })
                .catch(err => {
                    this.setState({ newPioMio: false, startDate: null, endDate: null });
                    if (err.response.data === 'Employee already has active pio mio!') {
                        toast('Zaposlenik već ima aktivan PIO/MIO. Unesite datum odjave kako biste dodali nove podatke.');
                    } else {
                        toast('Došlo je do greške! Podaci za PIO/MIO nisu sačuvani.');
                    }
                });
        } else {
            axios.put('pio-mio/', { ...obj })
                .then(res => {
                    this.setState({ editPioMio: false, startDate: null, endDate: null });
                    toast('Podaci za PIO/MIO su uspješno izmijenjeni.');

                    this.getPioMio();
                })
                .catch(err => {
                    this.setState({ editPioMio: false, startDate: null, endDate: null });
                    toast('Došlo je do greške! Podaci za PIO/MIO nisu izmijenjeni.');
                });
        }
    }

    editEmploymentInfo() {
        let obj = {
            optLock: this.state.optLockE,
            id: this.state.idE,
            kdo: this.state.kdo,
            workExperience: parseInt(this.state.workExperience)
        };

        axios.put('/hr/employee/update', { ...obj })
            .then(res => {
                this.setState({
                    editEmploymentInfo: false, newWork: false, kdo: null, workExperience: null, employee: res.data
                });
                localStorage.setItem('employee', JSON.stringify(res.data));
                toast('Podaci o zaposlenju su uspješno sačuvani.');
            })
            .catch(err => {
                this.setState({
                    editEmploymentInfo: false, newWork: false, kdo: null, workExperience: null
                });
                toast('Došlo je do greške! Podaci o zaposlenju nisu uspješno sačuvani.');
            });
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        const {
            employee, pioMio, main, editPioMio, editEmploymentInfo
        } = this.state;
        return (
            <div>
                <Grid columns={2}>
                    <Grid.Column>
                        <Divider horizontal>
                            <Header as="h4">
                                Podaci o zaposlenju
                            </Header>
                        </Divider>

                        <Table celled unstackable compact size="small">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Radno iskustvo</Table.HeaderCell>
                                    <Table.HeaderCell> Koeficijent dodatka po drugim osnovama</Table.HeaderCell>
                                    {(this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:')
                                    && <Table.HeaderCell verticalAlign="middle" textAlign="center" >
                                        {!(employee.workExperience || employee.kdo) && <Button
                                            icon="add"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            compact
                                            onClick={() => this.setState({
                                                editEmploymentInfo: true,
                                                kdo: employee.kdo,
                                                workExperience: employee.workExperience,
                                                idE: employee.id,
                                                newWork: true,
                                                optLockE: employee.optLock
                                            })}
                                        />}
                                    </Table.HeaderCell>}
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {(employee.workExperience || employee.kdo || this.state.newWork) && <Table.Row>
                                    <Table.Cell textAlign="left" verticalAlign="middle">
                                        {editEmploymentInfo ?
                                            <Form>
                                                <Form.Field
                                                    control={Input}
                                                    placeholder="Unesite radno iskustvo"
                                                    value={this.state.workExperience}
                                                    name="workExperience"
                                                    type="number"
                                                    onChange={this.handleInputChange}
                                                />
                                            </Form>
                                            : employee.workExperience ? employee.workExperience : ''}
                                    </Table.Cell>
                                    <Table.Cell textAlign="left" verticalAlign="middle">
                                        {editEmploymentInfo ?
                                            <Form>
                                                <Form.Field
                                                    control={Input}
                                                    placeholder="KDO"
                                                    value={this.state.kdo}
                                                    name="kdo"
                                                    type="number"
                                                    onChange={this.handleInputChange}
                                                />
                                            </Form>
                                            : employee.kdo ? employee.kdo : ''}
                                    </Table.Cell>
                                    {(main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') &&
                                    <Table.Cell textAlign="center" verticalAlign="middle">
                                        {editEmploymentInfo ?
                                            <div>
                                                <Button color="blue" circular compact icon="check" onClick={this.editEmploymentInfo} />
                                                <Button
                                                    color="blue"
                                                    basic="true"
                                                    circular
                                                    compact
                                                    icon="close"
                                                    onClick={() => this.setState({
                                                        editEmploymentInfo: false, newWork: false, kdo: null, workExperience: null, optLockE: null, idE: null
                                                    })}
                                                />
                                            </div>
                                            : <Button
                                                onClick={() => this.setState({
                                                    editEmploymentInfo: true,
                                                    kdo: employee.kdo,
                                                    workExperience: employee.workExperience,
                                                    idE: employee.id,
                                                    optLockE: employee.optLock
                                                })}
                                                basic="true"
                                                color="green"
                                                circular
                                                compact
                                                icon="pencil"
                                                size="small"
                                            />}
                                    </Table.Cell>}
                                </Table.Row>}
                            </Table.Body>
                        </Table>
                    </Grid.Column>

                    <Grid.Column>
                        <Divider horizontal>
                            <Header as="h4">
                                Podaci za PIO/MIO
                            </Header>
                        </Divider>
                        <Table celled unstackable compact size="small">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Datum prijave</Table.HeaderCell>
                                    <Table.HeaderCell>Datum odjave</Table.HeaderCell>
                                    {(this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') &&
                                    <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center">
                                        <Popup
                                            content="Dodaj podatke"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    icon="add"
                                                    size="small"
                                                    basic="true"
                                                    color="blue"
                                                    circular
                                                    compact
                                                    onClick={() => this.setState({ newPioMio: true, editPioMio: false })}
                                                />}
                                        />
                                    </Table.HeaderCell>}
                                </Table.Row>
                            </Table.Header>
                            {(pioMio.length || this.state.newPioMio) ?

                                <Table.Body>
                                    {this.state.newPioMio && <Table.Row>
                                        <Table.Cell verticalAlign="middle">
                                            <Form>
                                                <Form.Field>
                                                    <DateTimePicker
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        onChange={this.handleDateChange.bind(null, 'startDate')}
                                                        value={this.state.startDate}
                                                    />
                                                </Form.Field>
                                            </Form>
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            <Form>
                                                <Form.Field>
                                                    <DateTimePicker
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        onChange={this.handleDateChange.bind(null, 'endDate')}
                                                        value={this.state.endDate}
                                                    />
                                                </Form.Field>
                                            </Form>
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" textAlign="center">
                                            <Button color="blue" circular compact icon="check" onClick={this.editPioMio} />
                                            <Button color="blue" circular compact icon="close" basic="true" onClick={() => this.setState({ newPioMio: false, startDate: null, endDate: null })} />
                                        </Table.Cell>
                                    </Table.Row>}
                                    {pioMio.map((el, index) => (
                                        <Table.Row key={index}>
                                            <Table.Cell verticalAlign="middle">
                                                {editPioMio === index ? <Form>
                                                    <Form.Field>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            onChange={this.handleDateChange.bind(null, 'startDate')}
                                                            value={this.state.startDate ? new Date(this.state.startDate) : null}
                                                        />
                                                    </Form.Field>
                                                </Form>
                                                    : el.startDate ? moment(el.startDate).format('D. M. YYYY.') : ''}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {editPioMio === index ? <Form>
                                                    <Form.Field>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            onChange={this.handleDateChange.bind(null, 'endDate')}
                                                            value={this.state.endDate ? new Date(this.state.endDate) : null}
                                                        />
                                                    </Form.Field>
                                                </Form>
                                                    : el.endDate ? moment(el.endDate).format('D. M. YYYY.') : ''}
                                            </Table.Cell>
                                            {(main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Table.Cell verticalAlign="middle" textAlign="center">
                                                {editPioMio === index ? <div>
                                                    <Button color="blue" circular compact icon="check" onClick={this.editPioMio} />
                                                    <Button color="blue" circular compact icon="close" basic="true" onClick={() => this.setState({ editPioMio: false, startDate: null, endDate: null })} />
                                                </div>
                                                    : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {this.state.confirmation !== index && <Button
                                                            color="green"
                                                            circular
                                                            compact
                                                            icon="pencil"
                                                            basic="true"
                                                            onClick={() => this.setState({
                                                                editPioMio: index, startDate: el.startDate, endDate: el.endDate, id: el.id, optLock: el.optLock
                                                            })}
                                                        />}
                                                        {this.state.confirmation === index ?
                                                            <div>
                                                                <h4>Jeste li sigurni?</h4>
                                                                <Button.Group>
                                                                    <Button
                                                                        basic="true"
                                                                        color="blue"
                                                                        onClick={() => this.deletePioMio(el.id)}
                                                                    > DA</Button>
                                                                    <Button
                                                                        basic="true"
                                                                        color="red"
                                                                        onClick={(e) => { this.setState({ confirmation: false }); }}
                                                                    >  NE

                                                                    </Button>
                                                                </Button.Group></div>
                                                            : <div>
                                                                <Button
                                                                    icon="trash alternate"
                                                                    circular
                                                                    compact
                                                                    basic="true"
                                                                    color="red"
                                                                    onClick={() => this.setState({ confirmation: index })}
                                                                />
                                                            </div>}
                                                    </div>

                                                }
                                            </Table.Cell>}
                                        </Table.Row>))}
                                </Table.Body>
                                : this.state.loading ? <div><br /><Loader active inline="centered" /></div> : <p> Nema unesenih podataka za PIO/MIO.</p>}
                        </Table>
                    </Grid.Column>
                </Grid>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/HR/profile/Employee/PioMio.js